export default __webpack_public_path__ + "static/media/structure.4127b362.png";